module.exports = __webpack_public_path__ + "img/emty-data-homework.808d9b15.svg";